(function(){
  var PHONE='971503956060';
  function hideApp(){
    var H=window.innerHeight;
    var els=document.querySelectorAll('body *');
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(el.id==='nw-wa'||el.closest('#nw-wa'))continue;
      if(el.dataset&&el.dataset.nwWa)continue;
      if(el.closest('.nw-bar, .header-wrapper, cart-drawer, .drawer, main'))continue;
      var cs=getComputedStyle(el);
      if(cs.position!=='fixed')continue;
      var r=el.getBoundingClientRect();
      if(r.width<20||r.width>130||r.height<20||r.height>130)continue;
      if(r.bottom<H-220)continue;
      var txt=(el.id+' '+el.className+' '+(el.innerHTML||'').slice(0,4000)).toLowerCase();
      var isWa=txt.indexOf('whatsapp')>-1||txt.indexOf('wa.me')>-1||txt.indexOf('ck-')>-1||el.shadowRoot||cs.backgroundColor.indexOf('37, 211, 102')>-1;
      if(!isWa)continue;
      el.dataset.nwWa='1';
      el.style.setProperty('display','none','important');
    }
  }
  function addBtn(){
    if(document.getElementById('nw-wa'))return;
    var s=document.createElement('style');
    s.textContent='#nw-wa{position:fixed;right:14px;bottom:calc(16px + env(safe-area-inset-bottom));z-index:29;width:44px;height:44px;border-radius:50%;background:#25D366;display:flex;align-items:center;justify-content:center;box-shadow:0 3px 10px rgba(0,0,0,.18);transition:bottom .25s ease}#nw-wa svg{width:24px;height:24px;fill:#fff}html body .nw-bar{padding-right:16px!important}';
    document.head.appendChild(s);
    var a=document.createElement('a');
    a.id='nw-wa';a.href='https://wa.me/'+PHONE;a.target='_blank';a.rel='noopener';a.setAttribute('aria-label','WhatsApp');
    a.innerHTML='<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3C8.8 3 3 8.7 3 15.8c0 2.5.7 4.9 2 7L3 29l6.4-2c2 1.1 4.3 1.7 6.6 1.7 7.2 0 13-5.7 13-12.8S23.2 3 16 3zm0 23.4c-2.1 0-4.1-.6-5.9-1.7l-.4-.3-3.8 1.2 1.2-3.7-.3-.4c-1.2-1.8-1.9-3.8-1.9-5.9C4.9 9.8 9.9 4.9 16 4.9s11.1 4.9 11.1 10.9S22.1 26.4 16 26.4zm6.1-8.1c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1.1 1.3-.2.2-.4.3-.7.1-.3-.2-1.4-.5-2.7-1.7-1-.9-1.7-2-1.9-2.3-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6l-1-2.5c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.2 2.4 3.7 5.9 5.1 2.9 1.1 3.5.9 4.1.8.6-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.6-.4z"/></svg>';
    document.body.appendChild(a);
    var t=0;
    function pos(){
      t=0;
      var bar=document.querySelector('.nw-bar.is-on');
      var b=16;
      if(bar){var r=bar.getBoundingClientRect();if(r.top<window.innerHeight-2){b=Math.round(window.innerHeight-r.top)+12}}
      a.style.bottom=bar?(b+'px'):'calc(16px + env(safe-area-inset-bottom))';
    }
    var tt;window.addEventListener('scroll',function(){if(!t){t=requestAnimationFrame(pos)}clearTimeout(tt);tt=setTimeout(pos,320)},{passive:true});
    setTimeout(pos,400);
  }
  /* ===== cart upsell: "جرّب كمان" ===== */
  var upsCache={},upsBusy=false;
  function money(c){var n=(c/100);return (n%1?n.toFixed(2):String(n))+' د.إ'}
  function upsCss(){
    if(document.getElementById('nw-ups-css'))return;
    var s=document.createElement('style');s.id='nw-ups-css';
    s.textContent='.nw-ups{padding:1.2rem 1.6rem 1rem;border-top:1px solid rgba(0,0,0,.08)}.nw-ups__t{font-size:1.4rem;font-weight:700;margin:0 0 1rem;color:#003b2b}.nw-ups__l{display:grid;gap:.8rem}.nw-ups__i{display:grid;grid-template-columns:5.6rem 1fr auto;gap:1.2rem;align-items:center;background:#faf7f0;border:1px solid rgba(0,59,43,.15);border-radius:14px;padding:.8rem}.nw-ups__i img{width:5.6rem;height:5.6rem;object-fit:cover;border-radius:10px;display:block}.nw-ups__n{font-size:1.25rem;font-weight:600;line-height:1.4;color:#1e1e1e;margin:0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}.nw-ups__p{font-size:1.2rem;color:rgba(30,30,30,.7);margin:.2rem 0 0}.nw-ups__b{border:1px solid #003b2b;background:#003b2b;color:#f5e6c8;border-radius:30px;font-size:1.2rem;font-weight:600;padding:0 1.4rem;height:3.4rem;min-width:6rem;cursor:pointer;font-family:inherit}.nw-ups__b[disabled]{opacity:.5}';
    document.head.appendChild(s);
  }
  function getJSON(u){return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw 0;return r.json()})}
  function candidates(pid){
    if(upsCache[pid])return Promise.resolve(upsCache[pid]);
    return getJSON('/recommendations/products.json?product_id='+pid+'&limit=10').then(function(j){return j.products||[]}).catch(function(){return []}).then(function(list){
      if(list.length>=2)return list;
      return getJSON('/collections/all/products.json?limit=30').then(function(j){
        var more=(j.products||[]).map(function(p){var v=(p.variants||[])[0]||{};return{id:p.id,title:p.title,handle:p.handle,available:(p.variants||[]).some(function(x){return x.available}),featured_image:(p.images&&p.images[0]&&p.images[0].src)||'',price:Math.round(parseFloat(v.price||0)*100),variants:(p.variants||[]).map(function(x){return{id:x.id,available:x.available}})}});
        return list.concat(more);
      }).catch(function(){return list});
    }).then(function(l){upsCache[pid]=l;return l});
  }
  function img(u,w){if(!u)return '';u=u.indexOf('//')===0?'https:'+u:u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
  /* ===== free shipping bar (450 AED) ===== */
  var FS=45000;
  function fsCss(){
    if(document.getElementById('nw-fs-css'))return;
    var s=document.createElement('style');s.id='nw-fs-css';
    s.textContent='.nw-fs{padding:1rem 1.6rem 1.2rem;border-bottom:1px solid rgba(0,0,0,.08)}.nw-fs__t{margin:0 0 .7rem;font-size:1.25rem;line-height:1.5;text-align:center;color:#1e1e1e}.nw-fs__t b{color:#003b2b;font-weight:700}.nw-fs__b{height:6px;background:rgba(0,59,43,.12);border-radius:6px;overflow:hidden}.nw-fs__b span{display:block;height:100%;width:0;background:#003b2b;border-radius:6px;transition:width .4s ease}';
    document.head.appendChild(s);
  }
  function fsBar(cart){
    var dr=document.querySelector('cart-drawer');if(!dr)return;
    var inner=dr.querySelector('.drawer__inner');if(!inner)return;
    var el=inner.querySelector('.nw-fs');
    if(!cart.item_count){if(el)el.remove();return}
    fsCss();
    if(!el){
      el=document.createElement('div');el.className='nw-fs';
      el.innerHTML='<p class="nw-fs__t"></p><div class="nw-fs__b"><span></span></div>';
      var hd=inner.querySelector('.drawer__header');
      if(hd&&hd.parentNode===inner)inner.insertBefore(el,hd.nextSibling);else inner.insertBefore(el,inner.firstChild);
    }
    var t=cart.total_price,left=FS-t,pct=Math.max(4,Math.min(100,Math.round(t/FS*100)));
    el.querySelector('.nw-fs__t').innerHTML=left>0?'باقي لك <b>'+money(left)+'</b> وتحصل على <b>شحن مجاني</b>':'مبروك! طلبك عليه <b>شحن مجاني</b>';
    el.querySelector('.nw-fs__b span').style.width=pct+'%';
  }
  function nwUpsell(){
    var dr=document.querySelector('cart-drawer');if(!dr||upsBusy)return;
    var inner=dr.querySelector('.drawer__inner');if(!inner)return;
    upsBusy=true;
    getJSON('/cart.js').then(function(cart){
      fsBar(cart);
      var old=inner.querySelector('.nw-ups');
      if(!cart.items.length){if(old)old.remove();return}
      var inCart={};cart.items.forEach(function(it){inCart[it.product_id]=1});
      var key=Object.keys(inCart).sort().join(',');
      if(old&&old.dataset.key===key)return;
      return candidates(cart.items[0].product_id).then(function(list){
        var seen={},pick=[];
        list.forEach(function(p){if(pick.length<2&&!inCart[p.id]&&!seen[p.id]&&p.available!==false){seen[p.id]=1;pick.push(p)}});
        var cur=inner.querySelector('.nw-ups');if(cur)cur.remove();
        if(!pick.length)return;
        upsCss();
        var box=document.createElement('div');box.className='nw-ups';box.dataset.key=key;
        var t=document.createElement('p');t.className='nw-ups__t';t.textContent='جرّبه وياه';box.appendChild(t);
        var l=document.createElement('div');l.className='nw-ups__l';box.appendChild(l);
        pick.forEach(function(p){
          var v=(p.variants||[]).filter(function(x){return x.available!==false})[0];if(!v)return;
          var row=document.createElement('div');row.className='nw-ups__i';
          var a=document.createElement('a');a.href='/products/'+p.handle;
          var im=document.createElement('img');im.src=img(p.featured_image,160);im.alt='';im.loading='lazy';a.appendChild(im);
          var mid=document.createElement('div');
          var n=document.createElement('p');n.className='nw-ups__n';n.textContent=p.title;
          var pr=document.createElement('p');pr.className='nw-ups__p';pr.textContent=(p.variants&&p.variants.length>1?'من ':'')+money(p.price);
          mid.appendChild(n);mid.appendChild(pr);
          var b=document.createElement('button');b.type='button';b.className='nw-ups__b';b.textContent='أضف';
          b.addEventListener('click',function(){
            b.disabled=true;
            fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})}).then(function(r){return r.json()}).then(function(j){
              if(j.status){window.location.href='/products/'+p.handle;return}
              dr.renderContents(j);
            }).catch(function(){window.location.href='/products/'+p.handle});
          });
          row.appendChild(a);row.appendChild(mid);row.appendChild(b);l.appendChild(row);
        });
        var foot=inner.querySelector('.drawer__footer');
        if(foot)inner.insertBefore(box,foot);else inner.appendChild(box);
      });
    }).catch(function(){}).then(function(){upsBusy=false});
  }
  function upsSoon(){setTimeout(nwUpsell,120)}
  if(window.customElements){customElements.whenDefined('cart-drawer').then(function(){
    var C=customElements.get('cart-drawer');if(!C||C.prototype.__nwPatched)return;
    var o=C.prototype.renderContents;C.prototype.__nwPatched=true;
    C.prototype.renderContents=function(st){
      this.classList.remove('is-empty');
      var i=this.querySelector('.drawer__inner');if(i)i.classList.remove('is-empty');
      var r=o.call(this,st);upsSoon();return r;
    };
  })}
  function run(){addBtn();hideApp();nwUpsell();try{if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&!window.__nwSub){window.__nwSub=1;subscribe(PUB_SUB_EVENTS.cartUpdate,upsSoon)}}catch(e){}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run)}else{run()}
  window.addEventListener('load',function(){run();setTimeout(hideApp,1500);setTimeout(hideApp,4000);setTimeout(hideApp,8000)});
})();
